import { useEffect, useState } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import styles from "../styles/OurTeam.module.css";
import {
  fetchOurTeamPage,
  mapOurTeamPage,
} from "../helpers/contentfulHelper";

const OurTeam = () => {
  const [ourTeam, setOurTeam] = useState(null);

  useEffect(() => {
    const loadOurTeam = async () => {
      const entry = await fetchOurTeamPage();
      setOurTeam(mapOurTeamPage(entry));
    };

    loadOurTeam();
  }, []);

  if (!ourTeam) return null;

  return (
    <section className={styles.section}>
      <div className="contentWrapper">
        {/* Header */}
        <header className={styles.header}>
          <h2 className={styles.title}>{ourTeam.title}</h2>

          {ourTeam.introCopy && (
            <div className={styles.intro}>
              {documentToReactComponents(ourTeam.introCopy)}
            </div>
          )}
        </header>

        {/* Team grid */}
        <div className={styles.grid}>
          {ourTeam.teamMembers.map((member) => (
            <div key={member.id} className={styles.member}>
              {member.image && (
                <img
                  src={member.image}
                  alt={member.imageAlt}
                  loading="lazy"
                />
              )}

              {member.name ? <h3>{member.name}</h3> : null}
              {member.position ? <p>{member.position}</p> : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
